import React from 'react';
import ReactDOM from 'react-dom';
import styles from './modals.module.css';

export const RestoreImagesModal = ({
  isOpen,
  onClose,
  deletedImages,
  selectedImages,
  onToggleSelection,
  onSelectAll,
  onRestoreSelected
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.removeBgModalOverlay} onClick={onClose}>
      <div className={styles.removeBgModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.removeBgModalHeader}>
          <div className={styles.removeBgModalTitleContainer}>
            <h2 className={styles.removeBgModalTitle}>Restore Deleted Images</h2>
          </div>
          <button type="button" className={styles.removeBgModalClose} onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
            </svg>
          </button>
        </div>

        <div className={styles.removeBgModalDivider}></div>

        <div className={styles.removeBgModalContent}>
          <div className={styles.removeBgModalSelectionInfo}>
            <div className={styles.removeBgModalSelectionText}>
              <span>Select Images to Restore</span>
              <span className={styles.removeBgModalCount}>({selectedImages.size}/{deletedImages.length} Selected)</span>
            </div>
            <label className={styles.removeBgModalSelectAll}>
              <input type="checkbox" checked={selectedImages.size === deletedImages.length && deletedImages.length > 0} onChange={onSelectAll} />
              <span>Select All</span>
            </label>
          </div>

          <div className={styles.removeBgModalGrid}>
            {deletedImages.filter(imageData => imageData && imageData.image && imageData.uniqueId).map((imageData) => {
              const { image, uniqueId } = imageData;
              const isSelected = selectedImages.has(uniqueId);
              return (
                <div key={uniqueId} className={`${styles.removeBgModalImageCard} ${isSelected ? styles.removeBgModalImageCardSelected : ''}`} onClick={() => onToggleSelection(uniqueId)}>
                  <img src={image?.previewUrl || ''} alt="Deleted image" />
                  <div className={styles.removeBgModalCheckbox}>
                    {isSelected ? (
                      <div className={styles.removeBgModalCheckboxChecked}>
                        <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 3.5L3.5 6L8 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    ) : (
                      <div className={styles.removeBgModalCheckboxUnchecked}></div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <button type="button" className={styles.removeBgModalActionButton} onClick={onRestoreSelected} disabled={selectedImages.size === 0}>
            Restore Selected
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
